import type { Resource } from '../../';
export const product_sizeChart_category_unisex: Resource = {"default":"All Gender"};
